<div aria-live="assertive">
  @if (errorHandlerService.visible()) {
    <p-dialog
      [header]="'ERROR.DIALOG_TITLE' | translate"
      [modal]="true"
      [(visible)]="errorHandlerService.visible"
      [style]="{ maxWidth: '25rem' }"
      aria-describedby="error-dialog-message"
    >
      <p id="error-dialog-message">{{ errorHandlerService.translationKey() | translate }}</p>
      @if (errorHandlerService.serverMessage()) {
        <code class="block text-xs mt-component-5 bg-subtle rounded-sm p-component-3 border">{{
          errorHandlerService.serverMessage()
        }}</code>
      }
      @let shouldShowReqId =
        errorHandlerService.errorType() === 'server-error' && errorHandlerService.requestId();
      @if (shouldShowReqId) {
        <p class="mt-component-6 mb-component-3">
          {{ 'ERROR.REQUEST_ID_LABEL' | translate }}
        </p>
        <textarea pTextarea disabled variant="filled" autoResize="true" class="w-full">{{
          errorHandlerService.requestId()
        }}</textarea>
      }
      <ng-template #footer>
        <p-button
          severity="contrast"
          outlined="true"
          rounded="true"
          [label]="'CLOSE' | translate"
          (click)="errorHandlerService.dismiss()"
        />
        @if (errorHandlerService.errorType() === 'unauthorized') {
          <p-button
            [label]="'ERROR.REFRESH_PAGE' | translate"
            (click)="refresh()"
            icon="pi pi-replay"
            rounded="true"
          />
        } @else if (shouldShowReqId) {
          <p-button
            [label]="'ERROR.COPY_REQUEST_ID' | translate"
            icon="pi pi-copy"
            severity="primary"
            rounded="true"
            (click)="copyRequestId()"
          />
        }
      </ng-template>
    </p-dialog>
  }
</div>
